import React from 'react';
import { Logo } from './Logo';
import { Mail, MapPin, Linkedin, Twitter, Instagram } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    prodotto: [
      { label: 'Funzionalità', href: '#features' },
      { label: 'Come Funziona', href: '#how-it-works' },
      { label: 'Scarica App', href: '#download' },
    ],
    azienda: [
      { label: 'Chi Siamo', href: '#' },
      { label: 'Lavora con Noi', href: '#' },
      { label: 'Contatti', href: '#' },
    ],
    legale: [
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Termini di Servizio', href: '/terms' },
      { label: 'Cookie Policy', href: '/cookies' },
    ],
  };

  const socialLinks = [
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Instagram, href: '#', label: 'Instagram' },
  ];

  return (
    <footer className="bg-[rgb(0,55,32)] text-white py-16">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Logo size="default" light={true} className="mb-4" />
            <p className="text-white/70 mb-6 max-w-sm">
              Il motore di ricerca delle colonnine di ricarica. Confronta tutti gli operatori e trova sempre il prezzo migliore.
            </p>
            <div className="flex items-center gap-2 text-white/70 mb-2">
              <MapPin size={16} />
              <span>Milano, Italia</span>
            </div>
            <div className="flex items-center gap-2 text-white/70">
              <Mail size={16} />
              <a href="mailto:info@ezvi.it" className="hover:text-[#8FEC78] transition-colors">
                info@ezvi.it
              </a>
            </div>
          </div>

          {/* Links Columns */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Prodotto</h4>
            <ul className="space-y-3">
              {footerLinks.prodotto.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-white/70 hover:text-[#8FEC78] transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Azienda</h4>
            <ul className="space-y-3">
              {footerLinks.azienda.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-white/70 hover:text-[#8FEC78] transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Legale</h4>
            <ul className="space-y-3">
              {footerLinks.legale.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-white/70 hover:text-[#8FEC78] transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/50 text-sm">
            © {currentYear} EZVI. Tutti i diritti riservati.
          </p>
          
          {/* Social Links */}
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                aria-label={social.label}
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#8FEC78] transition-colors"
              >
                <social.icon size={18} />
              </a>
            ))}
          </div>

          <p className="text-white/50 text-sm">
            <a href="https://www.ezvi.it" className="hover:text-[#8FEC78] transition-colors">
              www.ezvi.it
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
